/* eslint-disable */
// @ts-nocheck
import { ORG_VIEW, APP_VIEW, AGENCY_VIEW } from '../../common/support/viewConstants';
import type { App } from '../../common/types/appTypes';
import type { Org, EntityUserRelation } from '../../common/types/orgTypes';
type PendoConfig = {
  userId: string;
  email: string;
  name: string;
  isAgencyUser: boolean;
  OnboardingStep?: string;
  currentApp?: App;
  currentOrg?: Org;
  currentAgency?: EntityUserRelation;
  primaryRole?: string;
};

class Pendo {
  isPendoLoaded() {
    return !!window.pendo;
  }

  initialize(config: PendoConfig) {
    const { userId, email, name, OnboardingStep, currentApp, currentOrg, currentAgency, isAgencyUser, primaryRole } = config;

    if (!this.isPendoLoaded()) {
      return;
    }

    const pendoPayload = {
      visitor: {
        id: userId,
        email,
        name,
        OnboardingStep,
        isAgencyUser,
        role: primaryRole,
      },
      account: {
        ...this.getBranchEntityIdAndName({
          currentApp,
          currentOrg,
          currentAgency,
        }),
      },
    };
    window.pendo.initialize(pendoPayload);
  }

  getBranchEntityIdAndName({
    currentApp,
    currentOrg,
    currentAgency,
  }: {
    currentApp?: App;
    currentOrg?: Org;
    currentAgency?: EntityUserRelation;
  }) {
    const { current_view: currentView, app_id: branchAppId, organization_id: branchOrgId } = window.App.context.view;

    if (currentView === APP_VIEW) {
      return {
        id: `app-${branchAppId}`,
        branchAppId,
        appName: currentApp && currentApp.name,
      };
    }

    if (currentView === ORG_VIEW) {
      return {
        id: `org-${branchOrgId}`,
        branchOrgId,
        orgName: currentOrg && currentOrg.name,
      };
    }

    if (currentView === AGENCY_VIEW) {
      return {
        id: `agency-${branchOrgId}`,
        branchAgencyId: branchOrgId,
        agencyName: currentAgency && currentAgency.organization_name,
      };
    }
  }

  event(eventName: string, data?: Record<string, any>) {
    if (this.isPendoLoaded() && eventName) {
      window.pendo.track(eventName, data);
    }
  }
}

export default Pendo;
